export const BUSINESS = {
  name: "Fast Track Auto Service & Tire Warehouse",
  phone: "+19164709450",
  phoneFormatted: "(916) 470-9450",
  address: {
    street: "643 Quarry Rd",
    city: "San Carlos",
    state: "CA",
    zip: "94070",
    full: "643 Quarry Rd, San Carlos, CA 94070",
  },
  hours: {
    weekdays: "8:00 AM – 10:00 PM",
    weekends: "8:00 AM – 10:00 PM",
    allDays: "Open 7 Days: 8:00 AM – 10:00 PM",
  },
  email: null, // TODO: verify with client
  website: "https://fasttracktireauto.com",
  googleMapsUrl: "https://maps.app.goo.gl/nePvHUhev6CBrEm79",
  yelpUrl: "https://www.yelp.com/biz/fast-track-tire-and-auto-service-redwood-city",
  rating: "4.9",
  reviewCount: "200+",
  yearEstablished: 2018, // TODO: verify with client
  tagline: "San Carlos's Trusted Auto Service & Tire Warehouse",
  tireBrands: ["Michelin", "Bridgestone", "Goodyear"],
  staff: [
    { name: "Ivan V.", role: "Manager" },
    { name: "Mohammad A.", role: "Owner" },
  ],
}
